import React, { useEffect, useState } from 'react';
import "./SimpleSearchBar.css";
import useDebounce from '../../uiUtils/useDebounce';

function SimpleSearchBar({ searchQuery, setSearchQuery }) {
  const [inputValue, setInputValue] = useState(searchQuery);
  const debouncedValue = useDebounce(inputValue, 500);

  useEffect(() => {
    setSearchQuery(debouncedValue);
  }, [debouncedValue, setSearchQuery]);

  return (
    <span className="simple-search-input-container">
      <img src="/img/search.png" className="simple-search-icon" alt="search" />
      <input
        type="text"
        placeholder="Search"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        className="simple-search-input"
      />
    </span>
  );
}

export default SimpleSearchBar;
